module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-Italic.cd979190.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-Italic.eot
// module id = 926
// module chunks = 0